
import { Account } from 'mastodon/components/account';
import { me } from 'mastodon/initial_state';

export const NavigationBar = () => {
  return (
    <div className='navigation-bar'>
      <Account id={me} minimal isShowPrivacyDropdown />
    </div>
  );
};
